module.exports = __webpack_public_path__ + "static/media/9DESA32.3c77d584.jpg";